export default "assets/images/logo-white-3daaffec.png";